<ng-container *ngIf="opened">
  <kendo-dialog [title]="referenceDataLabels.DeleteApplicantModalTitle | localizeLabel" (close)="close()" [width]="500">
    <div class="vo-info-box--danger">
      <span [innerHtml]="referenceDataLabels.DeleteApplicantModalText | localizeLabel"> </span>
    </div>

    <kendo-dialog-actions class="modal-buttons flex-column flex-md-row">
      <div class="left-column w-100-mobile">
        <a
          (click)="close()"
          [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
          class="link vo-secondary-button-1 w-100-mobile mb-15 mb-md-0"
        ></a>
      </div>
      <div class="right-column">
        <button
          for="submit-button"
          (click)="confirm()"
          [innerHtml]="referenceDataLabels.Delete | localizeLabel"
          class="primary-button vo-warning-button-1"
        ></button>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
